import { BASE_URL } from "../utils/EmpUtil";
import axios from "axios";
import { is401 } from "../errors/ErrorConstants";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";

export default class LocationDataClient {
  static getLocationData() {
    const url = BASE_URL + `/location-data`;
    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getDealerLocationData(dealerCommonId) {
    const encodedDealerCommonId = dealerCommonId
      ? encodeURIComponent(dealerCommonId)
      : "";
    const url =
      BASE_URL +
      `/dealer/location-data${
        encodedDealerCommonId ? `?dealerId=${encodedDealerCommonId}` : ""
      }`;
    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
